$(() => {
  if (!$('#owner-contact_for_admins_new').length) {
    return
  }

  const fileInput = $('#contact_for_admin_document_file')
  const MAX_FILE_SIZE = 50 * 1024 * 1024 // 50MB
  fileInput.on('change', (event) => {
    const target = event.target
    const file = target.files[0]
    // ファイルが選択されていない場合は何もしない
    if (!file) {
      return
    }

    // ファイルサイズをチェック
    if (file.size > MAX_FILE_SIZE) {
      alert('添付ファイルの合計サイズが上限（50MB）を超えています。\n50MB以内のファイルを添付してください。')
      $(target).val('') // ファイル選択をリセット
    }
  })
})
